import React from "react";

const getBusinessName = (businessName, props) => (
  <span
    role="button"
    tabIndex={0}
    onClick={() =>
      props.handleNewSearchClick(this, "business", businessName, {
        busname: businessName,
      })
    }
    className={"url-link"}
  >
    {businessName}
  </span>
);

export default getBusinessName;



// WEBPACK FOOTER //
// ./src/components/common/Business.js